var map = {
	"./config/languages.json": 3242,
	"./localazy.json": 6411,
	"./translations/en.json": 8602,
	"./translations/es.json": 5385,
	"./translations/fr.json": 6833,
	"./translations/sl.json": 1018,
	"./translations/sr.json": 9948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5105;